module.exports = __webpack_public_path__ + "img/recognition.9fc020dc.png";